import errorManager from '@/rollbar.js';

const textOfSelect = ($this, selector) => {
  const val = $this.find(':selected');
  if (val.length > 0 && val.attr('desc')) {
    $(selector.select_info).html(val.attr('desc'));
    window.GuestProtection.init(selector);
  }
};

const changeText = (evt, selector) => {
  let element, text;
  element = $(evt.target);
  let oldText = $(selector.area).val();
  let textModified = `${oldText} - ${element.text()} \n`;
  $(selector.area).val(textModified);
};

const setListener = (selector) => {
  const $select = $(selector.select);
  $select.on('change', (e) => {
    textOfSelect($(e.target), selector);
  });

  if (selector.done_selector && selector.hide_by_selector) {
    const $done_selector = $(selector.done_selector);
    $done_selector.on('change', (e) => {
      const el = $(e.target);
      const val = el.find(':selected');
      if (val.length > 0 && val.data('cod') && val.data('cod') == 'prot') {
        $(selector.hide_by_selector).show();
      } else {
        $(selector.hide_by_selector).hide();
      }
    });
  }

  const $handler = $(selector.handler);
  $handler.on('click', (e) => {
    changeText(e, selector);
  });
};

const init = (selector) => {
  try {
    setListener(selector);
  } catch (e) {
    errorManager(e);
  }
};

window.GuestProtection = {
  init: init,
};
